<template>
  <div class="edit_page">
    <div class="edit_wrapper"></div>
    <div class="edit">
      <div class="edit_top">
        <div class="edit_top_buttons">
          <router-link to="/beacons">
            <input type="button" :value="cancelButton" class="cancel_button" />
          </router-link>
          <input
            type="button"
            :value="addButton"
            class="finish_button"
            @click="showModal = true"
          />
        </div>
      </div>
      <div class="detail">
        <div class="detail_contents">
          <div class="location_name detail_content">
            <div class="location_name_label detail_label">
              {{ locationNameLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <input
              class="detail_input_field"
              type="text"
              @input="inputAddUpdate('locationName')"
            />
          </div>
          <div class="uuid detail_content">
            <div class="uuid_label detail_label">
              {{ uuidLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <input
              class="detail_input_field"
              type="text"
              @input="inputAddUpdate('uuid')"
            />
          </div>
          <div class="major detail_content">
            <div class="major_label detail_label">
              {{ majorLabel }}
            </div>
            <input
              class="detail_input_field"
              type="text"
              @input="inputAddUpdate('major')"
            />
          </div>
          <div class="minor detail_content">
            <div class="minor_label detail_label">
              {{ minorLabel }}
            </div>
            <input
              class="detail_input_field"
              type="text"
              @input="inputAddUpdate('minor')"
            />
          </div>
        </div>
      </div>
      <div class="modal_window" v-if="showModal">
        <addModalWindow @close="stayClose" @add="addBeacon"> </addModalWindow>
      </div>
      <div class="complete_modal_window" v-if="showCompleteModal">
        <completeModalWindow :question="completeWord" @close="close">
        </completeModalWindow>
      </div>
      <div class="complete_modal_window" v-if="showFailureModal">
        <completeModalWindow :question="failureWord" @close="stayClose">
        </completeModalWindow>
      </div>
      <div class="loading_modal_window" v-if="showloadingModal">
        <loadingModalWindow @close="close"> </loadingModalWindow>
      </div>
    </div>
  </div>
</template>

<script>
import addModalWindow from '../modalWindow/addModalWindow.vue'
import completeModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'

export default {
  data() {
    return {
      cancelButton: 'キャンセル',
      addButton: '追加',
      locationIdLabel: 'ビーコンID',
      locationNameLabel: '場所名',
      uuidLabel: 'UUID',
      majorLabel: 'メジャー値',
      minorLabel: 'マイナー値',
      completeWord: '',
      failureWord: '',
      showModal: false,
      showCompleteModal: false,
      showloadingModal: false,
      showFailureModal: false
    }
  },
  computed: {
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    requiredItemLabel() {
      return this.$store.state.error.requiredItemLabel
    }
  },
  created() {
    this.$store.dispatch('beacons/clearBeacon')
  },
  components: {
    addModalWindow,
    completeModalWindow,
    loadingModalWindow
  },
  methods: {
    inputAddUpdate(e) {
      this.$store.dispatch('beacons/inputAddUpdate', {
        name: e,
        value: event.target.value
      })
    },
    close(e) {
      this.showModal = false
      this.showCompleteModal = false
      this.$router.push('/beacons')
    },
    stayClose(e) {
      this.showModal = false
      this.showCompleteModal = false
      this.showFailureModal = false
    },
    async addBeacon(e) {
      this.showloadingModal = true
      try {
        await this.$store.dispatch('beacons/addBeacon')
        this.showModal = false
        this.completeWord = '追加しました。'
        this.showCompleteModal = true
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_420001
        let eventType = 3
        let reason = ''
        if (error.response && error.response.data) {
          if (error.response.data.header) {
            let errorMessage = error.response.data.header.message
            if (errorMessage === 'MSGCRC0077') {
              this.failureWord =
                this.errorMsg.MSGCRC0077.name +
                this.errorMsg.MSGCRC0077.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0078') {
              this.failureWord =
                this.errorMsg.MSGCRC0078.name +
                this.errorMsg.MSGCRC0078.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0113') {
              this.failureWord =
                this.errorMsg.MSGCRC0113.name +
                this.errorMsg.MSGCRC0113.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0114') {
              this.failureWord =
                this.errorMsg.MSGCRC0114.name +
                this.errorMsg.MSGCRC0114.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0116') {
              this.failureWord =
                this.errorMsg.MSGCRC0116.name +
                this.errorMsg.MSGCRC0116.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0117') {
              this.failureWord =
                this.errorMsg.MSGCRC0117.name +
                this.errorMsg.MSGCRC0117.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else {
              this.failureWord =
                this.errorMsg.MSGCRC0079.name +
                this.errorMsg.MSGCRC0079.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            }
            reason = errorMessage + ' '
            reason += error.response.status
          } else {
            if (error.response.data['data[0].major']) {
              this.failureWord =
                this.errorMsg.MSGCRC0119.name +
                this.errorMsg.MSGCRC0119.value +
                'エラーコード：{' +
                eventNumber +
                '}'
              reason = 'MSGCRC0119'
            } else if (error.response.data['data[0].minor']) {
              this.failureWord =
                this.errorMsg.MSGCRC0120.name +
                this.errorMsg.MSGCRC0120.value +
                'エラーコード：{' +
                eventNumber +
                '}'
              reason = 'MSGCRC0120'
            }
          }
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showModal = false
        this.showFailureModal = true
      }
      this.showloadingModal = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/beacons/beaconAdd.vue